export default "__VITE_ASSET__ByIU$MX9__"